import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, IconButton, Button, useMediaQuery, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';  // Importa el ícono para abrir el menú lateral
import logo from '../media/logo2.png';
import logoEmpresa from '../media/logoempresa.png';

import { CerrarSesion } from '../utils/componentes-utiles/CerrarSesion';
import { NotificacionFichar } from '../utils/componentes-utiles/NotificacionFichar';
import InstallPWA from '../utils/InstallPWA';

export const Header = ({ setOpenDrawer, openDrawer }) => {
	const [tokenusu, setTokenUsu] = useState('');
	const navigate = useNavigate();
	const location = useLocation();
	const isXs = useMediaQuery('(max-width:600px)'); // Detecta resolución xs


	useEffect(() => {
		setTokenUsu(localStorage.getItem('DesRepresentante'));
	}, [location]);

	return (
		<Grid container xs={12} justifyContent="space-between" direction="row" alignItems="center" padding="0.5em" className="header">
			{/* Ícono de menú lateral solo en pantallas pequeñas */}


			{/* Notificaciones */}
			{/* <NotificacionFichar /> */}

			{/* Nombre de usuario */}
			{tokenusu && (
				<Grid
					container
					xs={12} gap={1}
					justifyContent="space-between"
					direction="row"
					alignItems="center"
				>
					<Grid
						container
						direction="row"
						justifyContent={{ xs: 'center', sm: 'start' }}
						alignItems="center"
						xs={3} sm={3} md={2} lg={2} xl={2}
						sx={{
							ml: {
								xs: -1,
								sm: 1
							},
							// backgroundColor: 'red'
						}}
					>
						<IconButton
							edge="start"
							color="inherit"
							aria-label="menu"
							onClick={() => setOpenDrawer(!openDrawer)}  // Abre el menú lateral
						>
							<MenuIcon />
						</IconButton>

						<Grid
							container
							direction="row"
							justifyContent={{ xs: 'center', sm: 'start' }}
							alignItems="center"
							xs={6} sm={10} md={10} lg={10} xl={10}
						>
							{tokenusu ? <AccountCircleIcon sx={{ fontSize: 40 }} /> : ''}
							<Typography variant='body1' sx={{ textAlign: { xs: 'center', sm: 'left' } }}>&nbsp;{tokenusu}</Typography>
						</Grid>
					</Grid>

					<Grid
						container
						direction={{ xs: 'row', sm: 'row' }}
						justifyContent={{ xs: 'center', sm: 'space-evenly' }}
						alignItems="center"
						xs={4} sm={5} md={7.5}
					// sx={{ backgroundColor: 'blue' }}
					>
						{!isXs && (
							<Grid item xs={12} sm={5} md={3} lg={1.5}>
								<img src={logo} alt="Logo" className="logo-header pointer" style={{ maxWidth: '100%' }} onClick={() => navigate('/')} />
							</Grid>
						)}


						<Grid item xs={12} sm={5} md={3} lg={1.5}>
							<img src={logoEmpresa} alt="Logo" className="logo-header pointer" onClick={() => navigate('/')} />
						</Grid>

					</Grid>
					<Grid
						container
						direction="row"
						justifyContent="end"
						alignItems="center"
						xs={1} md={1}
					>
						<InstallPWA />
					</Grid>

					<Grid
						container
						direction="row"
						justifyContent="end"
						alignItems="center"
						xs={2} md={1}
					>
						<CerrarSesion />
					</Grid>

				</Grid>

			)
			}
		</Grid >
	);
};
